(function () {
  'use strict';

  if (window.__cpcPacksCart) return;
  window.__cpcPacksCart = true;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/;
  var TRASH = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><path d="M10.67 4v-.53c0-.75 0-1.12-.15-1.41a1.33 1.33 0 0 0-.58-.58C9.65 1.33 9.28 1.33 8.53 1.33H7.47c-.75 0-1.12 0-1.41.15-.25.13-.45.33-.58.58-.15.29-.15.66-.15 1.41V4M2 4h12M12.67 4v7.47c0 1.12 0 1.68-.22 2.11-.19.38-.5.68-.87.87-.43.22-.99.22-2.11.22H6.53c-1.12 0-1.68 0-2.11-.22a2 2 0 0 1-.87-.87c-.22-.43-.22-.99-.22-2.11V4"/></svg>';

  /* ---------- Semana Elixir (checkbox en la seccion) ----------
     30ml: pagas 3 y el 4to va gratis / 100ml: pagas 2 y el 3ro va gratis.
     El tamano lo define lo primero del carrito; si el carrito esta vacio,
     lo que el cliente elija en la pantalla "¿100ml o 30ml?". */
  var ELIXIR = {
    '100': { goal: 3, sub: 'Lleva 3 perfumes al precio de 2', ord: '3°', done: '¡Felicidades! Tu 3er perfume es gratis' },
    '30':  { goal: 4, sub: 'Lleva 4 perfumes al precio de 3', ord: '4°', done: '¡Felicidades! Tu 4to perfume es gratis' }
  };
  var ELIXIR_DEFAULT_SIZE = '100';
  var ELIXIR_KEY = 'cpcElixirSize';

  var excluded = new Set();
  var cart = null;
  var busy = false;

  /* ---------- utilidades ---------- */
  function readExcluded() {
    var el = document.querySelector('kaching-cart[kaching-cart-props]');
    if (!el) return;
    try {
      var p = JSON.parse(el.getAttribute('kaching-cart-props'));
      var tpb = p.cartSettings.tieredPromotionsBar;
      if (!tpb.excludeProductsFromUnlockCount) return;
      (tpb.productsExcludedFromUnlockCount || []).forEach(function (x) {
        excluded.add(String(x.productId).split('/').pop());
      });
    } catch (e) {}
  }

  function money(cents, fmt) {
    var n = (Math.abs(cents) / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    var flat = (Math.round(Math.abs(cents) / 100)).toLocaleString('es-MX');
    return (fmt || '$ {{amount}}')
      .replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, flat)
      .replace(/\{\{\s*amount[^}]*\}\}/, n);
  }

  function cfg(root) {
    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) {}
    tiers.sort(function (a, b) { return a.qty - b.qty; });
    return {
      tiers: tiers,
      slots: parseInt(root.getAttribute('data-slots') || '4', 10),
      fmt: root.getAttribute('data-money-format') || '$ {{amount}}',
      addUrl: root.getAttribute('data-add-url') || '/collections/all',
      elixir: root.getAttribute('data-elixir') === 'true'
    };
  }

  function names(root) {
    if (root.__cpcNames) return root.__cpcNames;
    var el = root.querySelector('[data-packs-names]');
    try { root.__cpcNames = JSON.parse(el.textContent); } catch (e) { root.__cpcNames = {}; }
    return root.__cpcNames;
  }

  function eligible(items) {
    return (items || []).filter(function (it) {
      return !excluded.has(String(it.product_id)) && it.original_line_price > 0;
    });
  }

  function detectSize(it) {
    var hay = [it.variant_title, it.product_title, it.title].join(' ');
    if (/100\s*ml/i.test(hay)) return '100';
    if (/\b30\s*ml/i.test(hay)) return '30';
    return null;
  }

  /* /cart.js lista lo mas reciente primero: el ultimo es el primero agregado */
  function cartSize(items) {
    for (var i = items.length - 1; i >= 0; i--) {
      var s = detectSize(items[i]);
      if (s) return s;
    }
    return null;
  }

  function storedSize() {
    try { return sessionStorage.getItem(ELIXIR_KEY); } catch (e) { return null; }
  }
  function storeSize(v) {
    try { sessionStorage.setItem(ELIXIR_KEY, v); } catch (e) {}
  }

  /* ---------- datos ---------- */
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; })
      .catch(function () { return null; });
  }

  function changeLine(key, qty) {
    if (busy) return Promise.resolve();
    if (window.cpcSuppressCart) window.cpcSuppressCart();
    busy = true;
    renderAll();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; })
      .catch(function () {})
      .then(function () {
        busy = false;
        renderAll();
        nudgeApps();
      });
  }

  function nudgeApps() {
    ['cart:refresh', 'cart:updated', 'shopify:cart:update'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
    });
    if (window.KachingCart && typeof window.KachingCart.refresh === 'function') {
      try { window.KachingCart.refresh(); } catch (e) {}
    }
  }

  /* ---------- render ---------- */
  function renderItems(root, c, map, items, showSlot, slotHint) {
    var wrap = root.querySelector('[data-packs-items]');
    var itemTpl = root.querySelector('[data-packs-item-tpl]');
    var slotTpl = root.querySelector('[data-packs-slot-tpl]');
    wrap.innerHTML = '';

    items.forEach(function (it) {
      var node = itemTpl.content.firstElementChild.cloneNode(true);
      var info = map[it.handle] || {};
      var short = info.short || String(it.product_title || it.title).split(' (')[0];
      var full = (info.full || it.product_title || it.title).replace(/[()]/g, '');

      var img = node.querySelector('.cpc-item__img');
      img.src = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      img.alt = short;

      node.querySelector('.cpc-item__name').textContent = short;
      node.querySelector('.cpc-item__title').textContent = full;
      node.querySelector('[data-qty]').textContent = it.quantity;
      node.querySelector('.cpc-item__price').textContent = money(it.original_line_price, c.fmt);

      var dec = node.querySelector('[data-act="dec"]');
      dec.innerHTML = it.quantity > 1 ? '−' : TRASH;
      dec.setAttribute('data-key', it.key);
      dec.setAttribute('data-next', it.quantity - 1);
      dec.setAttribute('aria-label', it.quantity > 1 ? 'Quitar una unidad' : 'Eliminar producto');

      var inc = node.querySelector('[data-act="inc"]');
      inc.setAttribute('data-key', it.key);
      inc.setAttribute('data-next', it.quantity + 1);

      node.classList.toggle('is-busy', busy);
      wrap.appendChild(node);
    });

    if (showSlot) {
      var slot = slotTpl.content.firstElementChild.cloneNode(true);
      slot.querySelector('.cpc-slot__hint').textContent = slotHint || '';
      wrap.appendChild(slot);
    }
  }

  function setSteps(root, total, active) {
    var stepsWrap = root.querySelector('[data-packs-steps]');
    if (!stepsWrap) return;
    if (stepsWrap.children.length !== total) {
      var h = '';
      for (var i = 0; i < total; i++) h += '<span class="cpc__step"></span>';
      stepsWrap.innerHTML = h;
    }
    for (var s = 0; s < stepsWrap.children.length; s++) {
      stepsWrap.children[s].classList.toggle('is-active', s < active);
    }
  }

  function setText(root, sel, html) {
    var el = root.querySelector(sel);
    if (el && el.innerHTML !== html) el.innerHTML = html;
  }

  /* Modo Semana Elixir */
  function renderElixir(root, c, map, items) {
    /* CM 21-oct: prioridad al 100 ml (el ticket más alto). Si solo hay 30 ml en el carrito, cambia solo a la promo del 30 ml */
    var has100 = items.some(function (it) { return detectSize(it) === '100'; });
    var has30 = items.some(function (it) { return detectSize(it) === '30'; });
    var size = has100 ? '100' : (has30 ? '30' : ELIXIR_DEFAULT_SIZE);

    root.setAttribute('data-view', 'builder');

    var E = ELIXIR[size];
    var goal = E.goal;

    var qty = 0, original = 0, finalSum = 0, groupQty = 0;
    items.forEach(function (it) {
      qty += it.quantity;
      original += it.original_line_price;
      finalSum += it.final_line_price;
      if (detectSize(it) === size) groupQty += it.quantity;
    });
    var discount = original - finalSum;
    if (discount < 0) discount = 0;

    setText(root, '.cpc__subtitle', E.sub);

    var status;
    if (groupQty >= goal) {
      status = E.done;
    } else {
      status = groupQty === 0
        ? 'Agrega ' + goal + ' perfumes y el ' + E.ord + ' va gratis'
        : 'Agrega ' + (goal - groupQty) + ' más y el ' + E.ord + ' va gratis';
    }
    setText(root, '[data-packs-status]', status);

    setSteps(root, goal, Math.min(groupQty, goal));

    renderItems(root, c, map, items, groupQty < goal, 'El ' + E.ord + ' va gratis');

    root.querySelector('[data-packs-discount]').textContent =
      discount > 0 ? '-' + money(discount, c.fmt) : money(0, c.fmt);
    root.querySelector('[data-packs-subtotal]').textContent = money(finalSum, c.fmt);
    root.setAttribute('data-qty', qty);
    /* CM 21-oct: con perfumes en el carrito se ve de una el avance de la promo (barra de pasos y lo que falta) */
    if (qty > 0) root.setAttribute('data-peek', 'false');
  }

  /* Modo original: tiers % */
  function renderTiers(root, c, map, items) {
    root.setAttribute('data-view', 'builder');

    var qty = 0, original = 0;
    items.forEach(function (it) { qty += it.quantity; original += it.original_line_price; });

    var pct = 0, nextTier = null;
    for (var i = 0; i < c.tiers.length; i++) {
      if (qty >= c.tiers[i].qty) pct = c.tiers[i].pct;
      else if (!nextTier) nextTier = c.tiers[i];
    }

    var discount = Math.round(original * pct / 100);
    var subtotal = original - discount;

    var status = '';
    if (qty === 0 && c.tiers[0]) {
      status = 'Agrega ' + c.tiers[0].qty + ' y obtén <strong>' + c.tiers[0].pct + '% OFF</strong>';
    } else if (nextTier) {
      var falta = nextTier.qty - qty;
      status = 'Agrega ' + falta + (falta === 1 ? ' mas' : ' mas') +
               ' y sube a <strong>' + nextTier.pct + '% OFF</strong>';
    } else {
      status = '¡Felicidades! Ahorraste <strong>' + money(discount, c.fmt) + '</strong>';
    }
    setText(root, '[data-packs-status]', status);

    setSteps(root, c.slots, Math.min(qty, c.slots));

    renderItems(root, c, map, items, qty < c.slots,
      nextTier ? 'Desbloquea ' + nextTier.pct + '% OFF' : '');

    root.querySelector('[data-packs-discount]').textContent =
      discount > 0 ? '-' + money(discount, c.fmt) : money(0, c.fmt);
    root.querySelector('[data-packs-subtotal]').textContent = money(subtotal, c.fmt);
    root.setAttribute('data-qty', qty);
  }

  function render(root) {
    if (!cart) return;

    var c = cfg(root);
    var map = names(root);
    var items = eligible(cart.items);

    if (c.elixir) renderElixir(root, c, map, items);
    else renderTiers(root, c, map, items);
  }

  function renderAll() {
    var roots = document.querySelectorAll('[data-packs-cart]');
    for (var i = 0; i < roots.length; i++) render(roots[i]);
  }

  /* ---------- eventos ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-packs-toggle]');
    if (toggle) {
      var root = toggle.closest('[data-packs-cart]');
      var collapsed = root.getAttribute('data-collapsed') === 'true';
      root.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      return;
    }

    /* Selector Semana Elixir */
    var opt = e.target.closest && e.target.closest('[data-packs-size]');
    if (opt) {
      var optRoot = opt.closest('[data-packs-cart]');
      var opts = optRoot.querySelectorAll('[data-packs-size]');
      for (var o = 0; o < opts.length; o++) opts[o].classList.toggle('is-selected', opts[o] === opt);
      return;
    }

    var next = e.target.closest && e.target.closest('[data-packs-next]');
    if (next) {
      var nextRoot = next.closest('[data-packs-cart]');
      var sel = nextRoot.querySelector('[data-packs-size].is-selected');
      storeSize(sel ? sel.getAttribute('data-packs-size') : ELIXIR_DEFAULT_SIZE);
      renderAll();
      return;
    }

    var btn = e.target.closest && e.target.closest('[data-act]');
    if (!btn || !btn.closest('[data-packs-cart]')) return;
    e.preventDefault();
    changeLine(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-next'), 10));
  });

  var timer = null;
  function refresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { loadCart().then(renderAll); }, delay == null ? 200 : delay);
  }

  var _fetch = window.fetch;
  window.fetch = function () {
    var url = String((arguments[0] && arguments[0].url) || arguments[0] || '');
    var res = _fetch.apply(this, arguments);
    /* CM 21-oct: lectura inmediata al terminar la mutación y otra de cierre. Antes refresh(800) cancelaba al de 150 ms y el sticky tardaba ~3 s */
    if (CART_MUTATION.test(url)) res.then(function () { loadCart().then(renderAll); refresh(800); }, function () {});
    return res;
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cpcUrl = String(u || ''); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (CART_MUTATION.test(this.__cpcUrl || '')) {
      this.addEventListener('loadend', function () { loadCart().then(renderAll); refresh(800); });
    }
    return _send.apply(this, arguments);
  };

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh(0);
  });

  readExcluded();
  loadCart().then(renderAll);
  setInterval(function () { if (!document.hidden) refresh(0); }, 8000);
})();

(function () {
  'use strict';

  if (window.__cpcNoDrawer) return;
  window.__cpcNoDrawer = true;

  var SCOPE = '.custom-packs-collections';
  var WINDOW_MS = 2500;
  var until = 0;
  var offTimer = null;

  function arm() {
    until = Date.now() + WINDOW_MS;
    document.documentElement.classList.add('cpc-suppress-cart');
    clearTimeout(offTimer);
    offTimer = setTimeout(disarm, WINDOW_MS);
  }

  function disarm() {
    until = 0;
    clearTimeout(offTimer);
    document.documentElement.classList.remove('cpc-suppress-cart');
  }

  function armed() { return Date.now() < until; }

  window.cpcSuppressCart = arm;

  // 1. Armar cuando el ATC nace dentro del pack
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"], .quick-add__submit, [data-act]');
    if (btn && btn.closest(SCOPE)) arm();
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest(SCOPE)) arm();
  }, true);

  // 2. Cerrar cualquier drawer que se abra durante la ventana
  function closeDrawers() {
    if (!armed()) return;

    var k = document.querySelector('#kaching-cart[data-open="true"], #kaching-cart.active');
    if (k) {
      var close = k.querySelector('.kaching-cart__close');
      if (close) close.click();
      else k.classList.remove('active');
    }

    var themeDrawer = document.querySelector('cart-drawer.active, cart-drawer.animate.active');
    if (themeDrawer && typeof themeDrawer.close === 'function') themeDrawer.close();

    if (k || themeDrawer) setTimeout(disarm, 300);
  }

  new MutationObserver(closeDrawers).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'data-open', 'open', 'style']
  });
})();

(function () {
  'use strict';

  if (window.__plCardExtraInfo) return;
  window.__plCardExtraInfo = true;

  /* Copy bajo cada product card (.custom-extra-info).
     Con "Semana Elixir" activo en la seccion usa los copies de la promo
     gratis; si no, los tiers % originales. */
  var TIERS_DEFAULT = ['10% OFF', '15% OFF', '20% OFF']; // con 1, 2 y 3 en el carrito
  var MAX_DEFAULT = 4;
  var EXCLUIR = []; // ids de producto que no cuentan (ej. el mini perfume de regalo)

  /* Tiers desde el data-tiers del arma tu set (Mes Patrio: 10/20/30). Sin caja: defaults. */
  function tiers() {
    var el = document.querySelector('[data-packs-cart][data-tiers]');
    var list = [];
    try { list = JSON.parse(el ? el.getAttribute('data-tiers') : '[]'); } catch (e) {}
    if (!list.length) return { labels: TIERS_DEFAULT, max: MAX_DEFAULT };
    list.sort(function (a, b) { return a.qty - b.qty; });
    var labels = list.map(function (t) { return t.pct + '% OFF'; });
    return { labels: labels, max: list[list.length - 1].qty };
  }

  var ELIXIR = {
    '100': { goal: 3, ord: 'el tercero', done: 'tercer' },
    '30':  { goal: 4, ord: 'el cuarto',  done: 'cuarto' }
  };
  var ELIXIR_DEFAULT_SIZE = '100';
  var ELIXIR_KEY = 'cpcElixirSize';

  var S = { qty: null, group: null, groupQty: 0 };

  function elixirOn() {
    var el = document.querySelector('[data-packs-cart]');
    return !!(el && el.getAttribute('data-elixir') === 'true');
  }

  function detectSize(it) {
    var hay = [it.variant_title, it.product_title, it.title].join(' ');
    if (/100\s*ml/i.test(hay)) return '100';
    if (/\b30\s*ml/i.test(hay)) return '30';
    return null;
  }

  function storedSize() {
    try { return sessionStorage.getItem(ELIXIR_KEY); } catch (e) { return null; }
  }

  function html() {
    if (S.qty === null) return null;

    if (!elixirOn()) {
      var q = S.qty;
      if (!q) return '';
      var T = tiers();
      if (q >= T.max) return 'Tienes <span>' + T.labels[T.labels.length - 1] + '</span>';
      return 'Agrega 1 más y obtén <span>' + (T.labels[q - 1] || T.labels[0]) + '</span>';
    }

    var size = S.group || storedSize() || ELIXIR_DEFAULT_SIZE;
    var E = ELIXIR[size];
    if (!E) return '';
    var gq = S.group ? S.groupQty : 0;
    if (gq >= E.goal) return 'Obtuviste tu <span>' + E.done + ' perfume gratis</span>';
    var falta = gq === 0 ? E.goal - 1 : E.goal - gq;
    return 'Agrega ' + falta + ' más y <span>' + E.ord + ' va gratis</span>';
  }

  function paint() {
    var h = html();
    if (h === null) return;
    var nodos = document.querySelectorAll('.custom-extra-info');
    for (var i = 0; i < nodos.length; i++) {
      if (nodos[i].innerHTML !== h) nodos[i].innerHTML = h;
    }
  }

  function loadCart() {
    /* CM perf 2026-10: la lectura usa el fetch de antes del wrapper de abajo. Con window.fetch
       la propia lectura de /cart.js disparaba refresh() y quedaba un bucle de ~1 request/s
       a /cart.js en todas las páginas (y las apps que escuchan el carrito re-leían cada vez). */
    return (_fetch || fetch).call(window, '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).filter(function (it) {
          if (EXCLUIR.indexOf(it.product_id) !== -1) return false;
          return it.original_line_price > 0; // líneas en $0 fuera
        });
        var n = 0;
        items.forEach(function (it) { n += it.quantity; });

        /* CM 21-oct: misma regla que la barra del set, prioridad al 100 ml y si solo hay 30 ml, la del 30 ml */
        var sizes = items.map(function (it) { return detectSize(it); });
        var g = sizes.indexOf('100') !== -1 ? '100' : (sizes.indexOf('30') !== -1 ? '30' : null);
        var gq = 0;
        if (g) {
          items.forEach(function (it) {
            if (detectSize(it) === g) gq += it.quantity;
          });
        }
        S.qty = n;
        S.group = g;
        S.groupQty = gq;
      })
      .catch(function () {});
  }

  var timer = null;
  function refresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { loadCart().then(paint); }, delay == null ? 250 : delay);
  }

  // Cualquier mutación del carrito por AJAX
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = String((arguments[0] && arguments[0].url) || arguments[0] || '');
    /* CM perf 2026-10: solo mutaciones (REST add/change/update/clear o GraphQL cartLines, cartCreate…).
       Antes cualquier lectura de /cart.js (de las apps o del bloque de arriba) re-disparaba esta lectura. */
    var isCart = /\/cart\/(add|change|update|clear)/.test(url) || (/graphql/.test(url) && /cartLines|cartCreate|cartAttributes|cartNote|cartDiscount/.test(String(arguments[1] && arguments[1].body || '')));
    var res = _fetch.apply(this, arguments);
    if (isCart) { res.then(function () { loadCart().then(paint); refresh(700); }, function () {}); }
    return res;
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__plUrl = String(u || ''); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (/\/cart\/(add|change|update|clear)/.test(this.__plUrl || '')) {
      this.addEventListener('loadend', function () { loadCart().then(paint); refresh(700); });
    }
    return _send.apply(this, arguments);
  };

  // Cards que se repintan (filtros de colección, quick add)
  var raf = null;
  new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; paint(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  refresh(0);
})();


(function () {
  'use strict';

  if (window.__cpcReveal) return;
  window.__cpcReveal = true;

  /* Mobile: la bottom sheet arranca oculta. Aparece en modo "peek" (solo titulo
     y subtitulo) para no tapar el CTA del hero, y pasa al estado compacto con un
     click o cuando el usuario sigue bajando. Una vez abierta, se queda. */
  var MQ = '(max-width: 749px)';
  var REVEALED = 'cpc-revealed';
  var SCROLL_TO_OPEN = 400; // px de scroll, contados desde que aparece

  function setPeek(on) {
    var els = document.querySelectorAll('[data-packs-cart]');
    for (var i = 0; i < els.length; i++) els[i].setAttribute('data-peek', on ? 'true' : 'false');
  }

  function revealAll() {
    var els = document.querySelectorAll('.custom-packs-collections-sidebar');
    for (var i = 0; i < els.length; i++) els[i].classList.add(REVEALED);
  }

  function init() {
    var wraps = document.querySelectorAll('.custom-packs-collections');
    if (!wraps.length) return;

    if (!window.matchMedia || !window.matchMedia(MQ).matches || !('IntersectionObserver' in window)) {
      setPeek(false);
      revealAll();
      return;
    }

    setPeek(true);

    var inView = false;
    var scrolled = window.scrollY > 0;
    var shown = false;
    var openAt = 0;
    var io;

    function show() {
      if (shown) return;
      shown = true;
      openAt = window.scrollY;
      revealAll();
      io.disconnect();
    }

    function check() { if (inView && scrolled) show(); }

    function open() {
      setPeek(false);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('click', onClick, true);
    }

    function onScroll() {
      scrolled = true;
      check();
      /* CM 21-oct: en celular el sticky se queda pequeñito (solo título y promo) hasta que lo toquen */
    }

    function onClick(e) {
      var root = e.target.closest && e.target.closest('[data-packs-cart]');
      if (!root || root.getAttribute('data-peek') !== 'true') return;
      e.preventDefault();
      e.stopPropagation(); // el primer click solo abre, no dispara el toggle
      open();
    }

    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) inView = true;
      check();
    }, { rootMargin: '0px 0px -30% 0px' });

    for (var w = 0; w < wraps.length; w++) io.observe(wraps[w]);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('click', onClick, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* CM 21-oct: en celular, con el carrito vacío, el selector "¿100ml o 30ml?" también queda pequeñito
   (solo título y subtítulo) mientras se navega. Al tocarlo se abre con las dos presentaciones. */
(function () {
  'use strict';
  if (window.__cmPacksSelectorCompacto) return;
  window.__cmPacksSelectorCompacto = true;
  var sel = '[data-packs-cart][data-view="selector"][data-collapsed="true"]';
  var css = '@media (max-width: 749px){' +
    sel + ' .cpc__selector-body{display:none!important}' +
    sel + ' .cpc__selector-header{padding:10px 16px!important;cursor:pointer}' +
    sel + ' .cpc__selector-title{font-size:19px!important;line-height:1.2!important;margin:0!important}' +
    sel + ' .cpc__selector-subtitle{font-size:12px!important;line-height:1.3!important;margin:2px 0 0!important}' +
  '}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  window.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('.cpc__selector-header');
    if (!h) return;
    var root = h.closest('[data-packs-cart]');
    if (root && root.getAttribute('data-collapsed') === 'true') root.setAttribute('data-collapsed', 'false');
  }, true);
})();

/* CM 21-oct: en celular el botón de WhatsApp sube por encima de la barra del set para no tapar la flecha */
(function () {
  'use strict';
  if (window.__cmPacksWhatsapp) return;
  window.__cmPacksWhatsapp = true;
  var st = document.createElement('style');
  st.textContent = '@media (max-width: 749px){body.cm-packs-visible .whatsapp-container{bottom:calc(var(--cm-packs-h, 70px) + 12px)!important;transition:bottom .2s ease}}';
  document.head.appendChild(st);
  function sync() {
    var side = document.querySelector('.custom-packs-collections-sidebar.cpc-revealed');
    var root = side && side.querySelector('[data-packs-cart]');
    var h = root ? Math.round(root.getBoundingClientRect().height) : 0;
    document.body.classList.toggle('cm-packs-visible', h > 0);
    if (h > 0) document.documentElement.style.setProperty('--cm-packs-h', h + 'px');
  }
  function start() {
    sync();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(sync);
      document.querySelectorAll('[data-packs-cart]').forEach(function (el) { ro.observe(el); });
    }
    new MutationObserver(sync).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'data-peek', 'data-collapsed', 'data-view'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* CM 21-oct: al agregar desde las tarjetas se esconde el cajón de Kaching; su fondo oscuro también, para que en iPhone la página no quede opaca */
(function () {
  'use strict';
  if (window.__cmPacksOverlay) return;
  window.__cmPacksOverlay = true;
  var st = document.createElement('style');
  st.textContent = 'html.cpc-suppress-cart .kaching-cart__overlay,html.cpc-suppress-cart .kaching-cart{opacity:0!important;visibility:hidden!important;background:transparent!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;pointer-events:none!important;transition:none!important}';
  document.head.appendChild(st);
})();
